<!-- <div [ngClass]="processing ? 'processing' : ''" class="main">
  <router-outlet></router-outlet>
</div>
<mat-spinner *ngIf="processing" color="primary" class="spinner"></mat-spinner> -->
<div [ngClass]="(processing || processingTrackReport ) ? 'processing' : ''" class="main">
  <router-outlet></router-outlet>
</div>
<mat-spinner *ngIf="(processing ||  processingTrackReport )" color="primary" class="spinner"></mat-spinner>
 
 